module.exports = __webpack_public_path__ + "img/yoel_Circle.33675ca0.jpg";